__turbopack_context__.v({
  "fade-in-ux308bl": "authorisationsList-module-scss-module__GnLPzq__fade-in-ux308bl",
  "listWrapper": "authorisationsList-module-scss-module__GnLPzq__listWrapper",
  "skeleton-item": "authorisationsList-module-scss-module__GnLPzq__skeleton-item",
  "wrapper": "authorisationsList-module-scss-module__GnLPzq__wrapper",
});
